import React from 'react';

import { useRouteMatchStrict } from 'hooks/useRouteMatchStrict';
import { AdminNavigation } from 'containers/AdminNavigation';
import { AdminPageLayout } from 'design/adminPageLayout';
import { GiroPaymentsPageContent } from 'containers/GiroPaymentsPage/GiroPaymentsPageContent';

type MatchParams = {
  page: string;
};

export const GiroPaymentsPage = () => {
  const {
    params: { page: currentPageText },
  } = useRouteMatchStrict<MatchParams>();

  // Номер страницы из роутера приходит в виде текста.
  // Для дальнейшей работы значение приводится к числу.
  const currentPage = Number(currentPageText);

  return (
    <AdminPageLayout
      sidebarNode={<AdminNavigation />}
      contentNode={<GiroPaymentsPageContent currentPage={currentPage} />}
    />
  );
};
